/* eslint-disable */

import * as runtime from '../runtime';
import type {
  ValidatePromotionCodeRequestDto,
  ValidatePromotionCodeResponseDto,
} from '../models';

export interface ValidatePromotionCodeRequest {
  orgId: number;
  validatePromotionCodeRequestDto: ValidatePromotionCodeRequestDto;
}

export class PaymentsApi extends runtime.BaseAPI {

  async validatePromotionCode(requestParameters: ValidatePromotionCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidatePromotionCodeResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/payments/orgs/${encodeURIComponent(String(requestParameters.orgId))}/validate-promotion-code`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.validatePromotionCodeRequestDto,
    }, initOverrides);
    return response.json();
  }

}
